/* @flow */

import WebshopAnnouncementBarSettings from './WebshopAnnouncementBarSettings'
import WebshopAnnouncementBar from './WebshopAnnouncementBar'

type WidgetSettings = {
  announcement: string,
  background_color: string,
  font_color: string,
  font_size: number,
  font: string | null,
  height: number,
  ticker_speed: string,
  style: 'static' | 'ticker',
}

const widget = {
  component: WebshopAnnouncementBar,
  settings: WebshopAnnouncementBarSettings,

  available_children: [],
  label: 'Announcement Bar',
  fixed: true,

  default_settings: {
    announcement: '',
    background_color: '#272727',
    font_color: '#ffffff',
    font_size: 11,
    font: null,
    height: 30,
    ticker_speed: '10s',

    style: 'static',
  },

  default_style: {
    marginTop: 0,
    marginBottom: 0,
  },
}

export default widget
